import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { ArrowUpRight, Ticket } from "lucide-react";
import { Container } from "@/components/shared/PageHeader";
import { useHeaderState } from "@/lib/headerTheme";
import { fmtDate, fmtTime } from "@/lib/format";
import { AddToCalendar } from "@/components/events/AddToCalendar";
import { countdownState } from "@/lib/media";

/** Thin rail that slides in under the top bar once the hero has scrolled away: title · when · price · the one action. */
export const EventStickyBar = ({ ev, show }) => {
  const { hidden } = useHeaderState();
  const reduce = useReducedMotion();
  const time = fmtTime(ev.start_time, ev.end_time);
  const over = countdownState(ev).state === "over";
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: reduce ? 0 : -16, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: reduce ? 0 : -16, opacity: 0 }} transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
          className="fixed inset-x-0 z-30 border-b border-border/80 bg-background/85 backdrop-blur-xl transition-[top] duration-300 ease-out supports-[backdrop-filter]:bg-background/75"
          style={{ top: hidden ? 0 : 60 }}
          data-testid="event-sticky-bar"
        >
          <Container className="flex h-14 items-center justify-between gap-4">
            <div className="min-w-0">
              <p className="truncate font-display text-[16px] font-semibold tracking-[-0.01em] sm:text-[17px]" data-testid="event-sticky-title">{ev.title}</p>
              <p className="t-mono-sm truncate text-muted-foreground" data-testid="event-sticky-when">{fmtDate(ev.date, "EEEE d. MMMM")}{time ? ` · ${time}` : ""}{ev.location ? ` · ${ev.location}` : ""}</p>
            </div>
            <div className="flex shrink-0 items-center gap-3">
              {ev.price_text && <span className="hidden text-[15px] font-medium sm:inline" data-testid="event-sticky-price">{ev.price_text}</span>}
              {ev.tickets_enabled && !over && <a href="#billettar" className="hidden h-10 items-center gap-2 rounded-full bg-ink px-5 text-[14px] font-semibold text-paper transition-colors hover:bg-sol hover:text-ink lg:inline-flex" data-testid="event-sticky-ticket-button"><Ticket className="h-4 w-4" /> Billettar</a>}
              {!ev.tickets_enabled && !over && ev.ticket_url && <a href={ev.ticket_url} target="_blank" rel="noopener noreferrer" className="inline-flex h-10 items-center gap-2 rounded-full bg-ink px-5 text-[14px] font-semibold text-paper transition-colors hover:bg-sol hover:text-ink" data-testid="event-sticky-ticket-link">Billettar <ArrowUpRight className="h-4 w-4" /></a>}
              {!over && !ev.tickets_enabled && !ev.ticket_url && <AddToCalendar ev={ev} className="h-10 px-4 text-[14px]" testId="event-sticky-calendar" />}
            </div>
          </Container>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
